import React from "react";

/**
 * Inline SVG glyphs used across the auth screens. Kept here so the
 * "Check your email" envelope and the sign-in hub's email icon are sourced
 * from a single definition.
 */

export const EnvelopeIcon: React.FC<{
  size?: number;
  color?: string;
}> = ({ size = 32, color = "#171512" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="4.5"
      y="8.5"
      width="23"
      height="15"
      rx="2"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M5 9l11 8 11-8"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/**
 * Two opposing arrows — used as the "resend code" affordance on the OTP
 * screen. Inlines the mobile ``icon-swap-arrows.svg`` so the row can
 * inherit ``currentColor`` from the surrounding text.
 */
export const SwapArrowsIcon: React.FC<{
  size?: number;
  color?: string;
}> = ({ size = 16, color = "currentColor" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 17 16"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.602 11.1869C12.4029 10.9917 12.4028 10.6751 12.602 10.4798C12.8011 10.2845 13.1241 10.2845 13.3232 10.4797L15.0233 12.1463C15.119 12.2401 15.1727 12.3673 15.1727 12.4999C15.1727 12.6325 15.119 12.7597 15.0234 12.8535L13.3232 14.5202C13.1241 14.7155 12.8011 14.7155 12.602 14.5202C12.4028 14.3249 12.4028 14.0084 12.602 13.8131L13.4314 13H3.44262C2.59762 13 1.91262 12.3284 1.91262 11.5V8C1.91262 7.72387 2.14095 7.5 2.42262 7.5C2.70428 7.5 2.93262 7.72387 2.93262 8V11.5C2.93262 11.7761 3.16095 12 3.44262 12H13.4315L12.602 11.1869Z"
      fill={color}
    />
    <path
      d="M14.3226 8.5C14.041 8.5 13.8126 8.27613 13.8126 8V4.5C13.8126 4.22386 13.5843 4 13.3026 4H3.31375L4.14321 4.81309C4.3424 5.00834 4.34242 5.32492 4.14327 5.52019C3.94411 5.71547 3.6212 5.71549 3.42202 5.52025L1.7219 3.85369C1.62625 3.75993 1.57251 3.63275 1.5725 3.50013C1.57249 3.36751 1.62623 3.24033 1.72188 3.14656L3.42199 1.47978C3.62116 1.28452 3.94407 1.28452 4.14324 1.47978C4.34241 1.67504 4.34241 1.99163 4.14324 2.18689L3.31386 3H13.3026C14.1476 3 14.8326 3.67157 14.8326 4.5V8C14.8326 8.27613 14.6043 8.5 14.3226 8.5Z"
      fill={color}
    />
  </svg>
);

export const EmailGlyph: React.FC<{
  size?: number;
  color?: string;
}> = ({ size = 24, color = "#171512" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      x="3.5"
      y="6.5"
      width="17"
      height="11"
      rx="1.5"
      stroke={color}
      strokeWidth="1.5"
    />
    <path
      d="M4 7l8 6 8-6"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
